// src/pages/LeagueStandings.js
import React, { useMemo } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import { useData } from "./Cache";
import "./LeagueStandings.css";

function normalize(str = "") {
  return str
    .toLowerCase()
    .replace(/ç/g, "c")
    .replace(/ğ/g, "g")
    .replace(/ı/g, "i")
    .replace(/ö/g, "o")
    .replace(/ş/g, "s")
    .replace(/ü/g, "u")
    .replace(/[^a-z0-9 ]/g, "")
    .trim()
    .replace(/\s+/g, "-");
}

export default function LeagueStandings() {
  const { cityName, leagueName, seasonName } = useParams();
  const navigate = useNavigate();
  const { matches, teams, loading, error } = useData();

  // 1) Seçilen lig/şehir/sezon maçları
  const seasonMatches = useMemo(() => {
    if (!leagueName || !seasonName) return [];
    return matches.filter(m =>
      normalize(m.league_name) === leagueName &&
      normalize(m.city)        === cityName  &&
      normalize(m.match_season) === seasonName &&
      !m.is_it_fixture
    );
  }, [matches, cityName, leagueName, seasonName]);

  // 2) Puan tablosunu hesapla
  const standings = useMemo(() => {
    const table = {};
    seasonMatches.forEach((m) => {
      const H = m.first_team_name,
            A = m.second_team_name,
            HS = m.first_team_score,
            AS = m.second_team_score;
      if (!table[H]) table[H] = { name: H, played: 0, wins: 0, draws: 0, losses: 0, scored: 0, conceded: 0, points: 0 };
      if (!table[A]) table[A] = { name: A, played: 0, wins: 0, draws: 0, losses: 0, scored: 0, conceded: 0, points: 0 };

      table[H].played++; table[A].played++;
      table[H].scored += HS; table[H].conceded += AS;
      table[A].scored += AS; table[A].conceded += HS;

      if (HS > AS) {
        table[H].wins++; table[H].points += 3; table[A].losses++;
      } else if (HS < AS) {
        table[A].wins++; table[A].points += 3; table[H].losses++;
      } else {
        table[H].draws++; table[H].points++;
        table[A].draws++; table[A].points++;
      }
    });

    return Object.values(table).sort((a, b) =>
      b.points !== a.points
        ? b.points - a.points
        : (b.scored - b.conceded) - (a.scored - a.conceded)
    );
  }, [seasonMatches]);

  // 3) Logo bulucu
  const getLogo = (teamName) =>
    teams.find((t) => t.team_name === teamName)?.logo || "";

  // 4) Durumlar
  if (loading)  return <p className="ls-loading">Yükleniyor…</p>;
  if (error)    return <p className="ls-error">Hata: {error}</p>;

  // Eğer seasonName yoksa ya da maç yoksa mesaj göster
  if (!seasonName || !seasonMatches.length) {
    return (
      <>
        <Header />
        <p className="ls-no-data">Bu lig / sezon için henüz maç yok.</p>
        <Footer />
      </>
    );
  }

  // 5) Render tablo
  return (
    <>
      <Header />
      <div className="ls-container">
        <h1 className="ls-title">
          {decodeURIComponent(leagueName)} / {seasonName} Puan Tablosu
        </h1>
        <table className="ls-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Takım</th>
              <th>O</th>
              <th>G</th>
              <th>B</th>
              <th>M</th>
              <th>AG</th>
              <th>YG</th>
              <th>Av</th>
              <th>P</th>
              <th>İncele</th>
            </tr>
          </thead>
          <tbody>
            {standings.map((t, i) => (
              <tr key={t.name}>
                <td>{i + 1}</td>
                <td
                  className="ls-team-cell"
                  onClick={() =>
                    navigate(`/${cityName}/takimlar/${normalize(t.name)}`)
                  }
                >
                  <img src={getLogo(t.name)} alt="" className="ls-team-logo" />
                  <span>{t.name}</span>
                </td>
                <td>{t.played}</td>
                <td>{t.wins}</td>
                <td>{t.draws}</td>
                <td>{t.losses}</td>
                <td>{t.scored}</td>           {/* Attığı Gol */}
                <td>{t.conceded}</td>         {/* Yediği Gol */}
                <td>{t.scored - t.conceded}</td>
                <td>{t.points}</td>
                <td
                  className="ls-view-cell"
                  onClick={() =>
                    navigate(`/${cityName}/${leagueName}/${seasonName}/takimlar/${normalize(t.name)}`)
                  }
                >
                  ➡
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <Footer />
    </>
  );
}
